import React from 'react';
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Send
} from 'lucide-react';

const Footer = ({ setCurrentPage }) => {
  // كل رابط له href احتياطي، وبعضها له page مرتبطة بصفحة فعلية داخل التطبيق
  const quickLinks = [
    { name: 'الرئيسية', href: '#home', page: 'home' },
    { name: 'عن الصيدلية', href: '#about' },
    { name: 'المنتجات', href: '#products' },
    { name: 'الخدمات', href: '#services' },
    { name: 'العروض', href: '#offers' },
    { name: 'اتصل بنا', href: '#contact', page: 'contact' }
  ];

const categories = [
  { name: 'الأدوية والعلاج', href: '#medicines', page: 'medicines' },
  { name: 'الفيتامينات والتغذية', href: '#vitamins', page: 'vitamins' },
  { name: 'الأم والطفل', href: '#children-products', page: 'children-products' },
  { name: 'العناية الشخصية', href: '#personal-care', page: 'personal-care' },
  { name: 'الأجهزة والمستلزمات الطبية', href: '#medical-devices', page: 'medical-devices' },
  { name: 'الحماية والرعاية', href: '#protection', page: 'protection' },
  { name: 'العروض والباقات', href: '#offers', page: 'offers' }
];

  const legalLinks = [
    { name: 'سياسة الخصوصية', href: '#privacy', page: 'privacy' },
    { name: 'شروط الاستخدام', href: '#terms', page: 'terms' },
    { name: 'سياسة الإرجاع', href: '#returns', page: 'returns' },
    { name: 'طرق الدفع', href: '#payment', page: 'payment' },
    { name: 'الشحن والتوصيل', href: '#shipping', page: 'shipping' },
    { name: 'الأسئلة الشائعة', href: '#faq', page: 'faq' }
  ];

  const socialLinks = [
    { icon: <Facebook className="h-5 w-5" />, href: '#', name: 'Facebook' },
    { icon: <Twitter className="h-5 w-5" />, href: '#', name: 'Twitter' },
    { icon: <Instagram className="h-5 w-5" />, href: '#', name: 'Instagram' },
    { icon: <Youtube className="h-5 w-5" />, href: '#', name: 'YouTube' }
  ];


  const FooterLink = ({ link, className }) => {
    if (link.page && setCurrentPage) {
      return (
        <button type="button" onClick={() => setCurrentPage(link.page)} className={className}>
          {link.name}
        </button>
      );
    }
    return (
      <a href={link.href} className={className}>
        {link.name}
      </a>
    );
  };

  return (
    <footer className="bg-gray-900 font-['Cairo'] text-white">
      {/* القسم الرئيسي */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-4">
          {/* معلومات الصيدلية */}
          <div className="lg:col-span-1">
            <div className="mb-6 flex items-center">
              <div className="ml-3 flex h-12 w-12 items-center justify-center rounded-xl bg-[#10B981] text-lg font-bold text-white">
                ريان
              </div>
              <div>
                <h3 className="text-2xl font-bold">صيدلية الريان</h3>
                <p className="text-gray-400">صحتك أولويتنا</p>
              </div>
            </div>

            <p className="mb-6 leading-relaxed text-gray-300">
              نحن نقدم أفضل الأدوية والمنتجات الصحية بأعلى معايير الجودة والأمان،
              مع خدمة عملاء متميزة وتوصيل سريع.
            </p>

            {/* معلومات الاتصال */}
            <div className="space-y-3.5">
              <a href="tel:+966111234567" className="flex items-center gap-3 text-gray-300 transition-colors duration-200 hover:text-[#10B981]">
                <Phone className="h-5 w-5 flex-shrink-0 text-[#10B981]" />
                <span>+966 11 123 4567</span>
              </a>
              <a href="mailto:info@AlRayyan-pharmacy.com" className="flex items-center gap-3 text-gray-300 transition-colors duration-200 hover:text-[#10B981]">
                <Mail className="h-5 w-5 flex-shrink-0 text-[#10B981]" />
                <span>info@AlRayyan-pharmacy.com</span>
              </a>
              <div className="flex items-center gap-3 text-gray-300">
                <MapPin className="h-5 w-5 flex-shrink-0 text-[#10B981]" />
                <span>الرياض، المملكة العربية السعودية</span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Clock className="h-5 w-5 flex-shrink-0 text-[#10B981]" />
                <span>مفتوح 24/7</span>
              </div>
            </div>
          </div>

          {/* روابط سريعة */}
          <div>
            <h4 className="mb-6 text-xl font-bold">روابط سريعة</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <FooterLink
                    link={link}
                    className="text-gray-300 transition-colors duration-200 hover:text-[#10B981]"
                  />
                </li>
              ))}
            </ul>
          </div>

          {/* الفئات */}
          <div>
            <h4 className="mb-6 text-xl font-bold">الفئات</h4>
            <ul className="space-y-3">
              {categories.map((category, index) => (
                <li key={index}>
                  <FooterLink
                    link={category}
                    className="text-gray-300 transition-colors duration-200 hover:text-[#10B981]"
                  />
                </li>
              ))}
            </ul>
          </div>

          {/* النشرة الإخبارية */}
          <div>
            <h4 className="mb-6 text-xl font-bold">النشرة الإخبارية</h4>
            <p className="mb-4 text-gray-300">
              اشترك للحصول على آخر العروض والنصائح الصحية
            </p>

            <div className="mb-6 flex gap-2">
              <input
                type="email"
                placeholder="بريدك الإلكتروني"
                className="flex-1 rounded-xl border border-gray-700 bg-gray-800 px-3 py-2.5 text-white placeholder-gray-400 outline-none transition-colors duration-200 focus:border-[#10B981]"
              />
              <button
                className="flex-shrink-0 rounded-xl bg-[#10B981] p-2.5 transition-all duration-200 hover:bg-[#0ea173] active:scale-95"
                aria-label="اشترك"
              >
                <Send className="h-5 w-5" />
              </button>
            </div>

            {/* وسائل التواصل الاجتماعي */}
            <div>
              <h5 className="mb-4 font-semibold">تابعنا على</h5>
              <div className="flex gap-3">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    className="rounded-xl bg-gray-800 p-3 transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#10B981]"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* القسم السفلي */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col items-center justify-between gap-4 lg:flex-row">
            <div className="text-sm text-gray-400">© 2025 صيدلية الريان. جميع الحقوق محفوظة.</div>

            <div className="flex flex-wrap gap-x-6 gap-y-2">
              {legalLinks.map((link, index) => (
                <FooterLink
                  key={index}
                  link={link}
                  className="text-sm text-gray-400 transition-colors duration-200 hover:text-[#10B981]"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
